import {
	Box,
	Link as MuiLink,
	Stack,
	Typography,
	useTheme,
} from "@mui/material";
import { ChevronRight } from "lucide-react";
import type { FC, ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

interface DashboardNotificationSectionFrameProps {
	title: string;
	showAllHref?: string;
	children: ReactNode;
	testId?: string;
}

export const DashboardNotificationSectionFrame: FC<
	DashboardNotificationSectionFrameProps
> = ({ title, showAllHref, children, testId }) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<Stack data-testid={testId} bgcolor={theme.palette.grey[100]}>
			<Typography
				variant="overline"
				color={theme.palette.grey[500]}
				px={theme.spacingTokens.lg}
				pt={theme.spacingTokens.md}
				pb={theme.spacingTokens.sm}
			>
				{title}
			</Typography>
			{children}
			{showAllHref ? (
				<MuiLink
					component={RouterLink}
					to={showAllHref}
					underline="none"
					data-testid={testId ? `${testId}-show-all` : undefined}
				>
					<Stack
						direction="row"
						alignItems="center"
						gap={theme.spacingTokens.xs}
						px={theme.spacingTokens.lg}
						py={theme.spacingTokens.md}
					>
						<Typography variant="bodyMedium" color={theme.palette.blue[600]}>
							{t(Resources.Dashboard.NotificationSections.ShowAll)}
						</Typography>
						<ChevronRight
							size={theme.iconSize.sm}
							color={theme.palette.blue[600]}
						/>
					</Stack>
				</MuiLink>
			) : (
				<Box pb={theme.spacingTokens.md} />
			)}
		</Stack>
	);
};
